import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

//import BootstrapVue from 'bootstrap-vue'
//import SuiVue from 'semantic-ui-vue'
//import PortalVue from 'portal-vue'
//import VueScrollTo from 'vue-scrollto'
//import TextareaAutosize from 'vue-textarea-autosize'

const requireDirective = require.context(
    './',
    false,
    /Base[A-Z]\w+\.(vue|js)$/
)

requireDirective.keys().forEach(fileName => {
    const directiveConfig = requireDirective(fileName)

    const directiveName = upperFirst(
        camelCase(
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    )

    Vue.directive(directiveName, directiveConfig.default)
})

//Vue.use(BootstrapVue)
//Vue.use(SuiVue)
//Vue.use(PortalVue)
//Vue.use(VueScrollTo)
//Vue.use(TextareaAutosize)



